import { useState, useRef } from "react";
import Button from "./Button";
import { MdDriveFolderUpload } from "react-icons/md";

interface ImageUploaderProps {
  imgUrl?: string | null;
  onUpload: (file: File) => void | Promise<void>;
  label?: string;
  showAction?: boolean;
}

export default function ImageUploader({
  imgUrl,
  onUpload,
  label = "Upload Image",
  showAction,
}: ImageUploaderProps) {
  const [preview, setPreview] = useState<string | null>(imgUrl ?? null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const buttonClasses =
    "w-full justify-center font-bold p-2 bg-primary rounded text-white";

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.[0]) return;
    const file = e.target.files[0];

    setPreview(URL.createObjectURL(file));

    setLoading(true);
    try {
      await Promise.resolve(onUpload(file));
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  return (
    <div className="w-full flex flex-col items-center gap-3">
      <div
        className="w-32 h-32 rounded-2xl overflow-hidden shadow-md border bg-gray-50 flex items-center justify-center cursor-pointer"
        onClick={triggerFileInput}
      >
        {preview ? (
          <img
            src={preview}
            alt="Preview"
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-sm text-gray-400">
            <MdDriveFolderUpload className="text-xl" />
          </span>
        )}
      </div>

      {/* Hidden input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
      />

      {showAction && (
        <Button
          disabled={loading}
          onClick={triggerFileInput}
          className={buttonClasses}
        >
          {loading ? "Uploading..." : label}
        </Button>
      )}
    </div>
  );
}
